import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material'

interface TSAPIPreviewModalProps {
  open: boolean
  title: string
  jsonData: any
  url: string
  onClose: () => void
}

const TSAPIPreviewModal: React.FC<TSAPIPreviewModalProps> = ({
  open,
  title,
  jsonData,
  url,
  onClose,
}) => {
  const handleOpenInNewTab = () => {
    window.open(url, '_blank')
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: '80vw',
          height: '90vh',
          maxWidth: '80vw',
          maxHeight: '90vh',
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            backgroundColor: '#1e1e1e',
            color: '#d4d4d4',
            padding: 2,
            borderRadius: 1,
            fontFamily: 'monospace',
          }}
        >
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
            {JSON.stringify(jsonData, null, 2)}
          </pre>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
        <Button onClick={handleOpenInNewTab} variant="contained">
          Open in New Tab
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TSAPIPreviewModal
